import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faArrowRight,
  faTimes,
  faFilter,
} from "@fortawesome/free-solid-svg-icons";
import { Link, useNavigate } from "react-router-dom";
import cctv from "../assets/icons/cctv.png";
import transformer from "../assets/icons/transformer.png";
import dg from "../assets/icons/dg.png";
import boreWell from "../assets/icons/bore-well.png";
import wtp from "../assets/icons/wtp.png";
import stp from "../assets/icons/stp.png";
import motor from "../assets/icons/motor.png";
import firSafety from "../assets/icons/fire-safety.png";
import htlt from "../assets/icons/ht-lt.png";
import lift from "../assets/icons/lift.png";
import ServiceCard from "../components/common/service-card";
import filterService from "../services/filter-service";
import { useSearchParams } from "react-router-dom";
import { Accordion } from "react-bootstrap";
import homeService from "../services/home-page-services";
import { ProgressSpinner } from "primereact/progressspinner";
import Pagination from "../components/common/Pagination";

const Services = () => {
  const [services, setServices] = useState([]);
  const [searchParams, setSearchParams] = useSearchParams();
  const [expandedFilters, setExpandedFilters] = useState({});
  const [serviceImage, setServiceImage] = useState({});
  const [showFilters, setShowFilters] = useState(false);
  const [totalCount, setTotalCount] = useState(0);

  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [allFilter, setAllFilter] = useState([
    {
      filterType: "Locality",
      filteroptionname: "locality",
      filterOptions: [],
    },
    {
      filterType: "Type of Work",
      filteroptionname: "typeOfWork",
      filterOptions: [],
    },
    {
      filterType: "Type of Service",
      filteroptionname: "typeOfService",
      filterOptions: ["Consultation", "Execution"],
    },
    {
      filterType: "Premise Type",
      filteroptionname: "premiseType",
      filterOptions: ["Residential", "Commercial", "Industrial", "Mixed"],
    },
    {
      filterType: "Customer Ratings",
      filteroptionname: "sRating",
      filterOptions: ["3+ stars", "4+ stars", "5 stars"],
    },
    {
      filterType: "Service Urgency",
      filteroptionname: "serviceUngency",
      filterOptions: ["Regular", "Urgent", "Emergency"],
    },
    {
      filterType: "Provider Type",
      filteroptionname: "providerType",
      filterOptions: ["Verified Vendor", "Certified Technician", "OEM Service"],
    },
  ]);
  const typeOfWorkId = searchParams.get("typeOfWork") || null;

  const typeOfWorkOption = allFilter
    .find((f) => f.filterType === "Type of Work")
    ?.filterOptions.find((opt) => String(opt.id) === typeOfWorkId);
  const [filters, setFilters] = useState({
    pageSize: 10,
    pageNo: 1,
    fiterParam: "",
    category: searchParams.get("category") || "",
    subCategory:
      searchParams
        .get("subCategory")
        ?.replace(/\$/g, "&")
        ?.replace(/-/g, " ") || "",
    locality: searchParams.get("locality") || "",
    typeOfWork: typeOfWorkOption?.id || null,
    typeOfService: searchParams.get("typeOfService") || "",
    premiseType: searchParams.get("premiseType") || "",
    sRating: Number(searchParams.get("sRating")?.charAt(0)) || null,
  });
  useEffect(() => {
    const fetchLocalities = async () => {
      try {
        const response = await filterService.submitLocality();
        const localities =
          response.data?.result?.map((item) => item.locationName) || [];

        setAllFilter((prevFilters) =>
          prevFilters.map((filter) =>
            filter.filterType === "Locality"
              ? { ...filter, filterOptions: localities }
              : filter
          )
        );
      } catch (error) {
        console.error("Error fetching localities:", error);
      }
    };

    const fetchTypeofWork = async () => {
      try {
        const response = await filterService.getTypeOfWork();
        const typeofWork = response.data?.result || []; // use full item (id + name)
        setAllFilter((prevFilters) =>
          prevFilters.map((filter) =>
            filter.filterType === "Type of Work"
              ? { ...filter, filterOptions: typeofWork }
              : filter
          )
        );
      } catch (error) {
        console.error("Error fetching type of work:", error);
      }
    };

    fetchLocalities();
    fetchTypeofWork();
  }, []);
  useEffect(() => {
    const fetchAdsBanner = async () => {
      try {
        const response = await homeService.getAdsbanner();
        if (response) {
          setServiceImage(response.data.result);
        }
      } catch (error) {
        console.error("Error fetching banner:", error);
      }
    };

    fetchAdsBanner();
  }, []);
  const fetchServices = async () => {
    setLoading(true);
    try {
      const response = await filterService.filterServices(filters);
      const result = response.data.result;
      setServices(result || []);
      setTotalCount(result?.[0]?.totalCount || 0);
      console.log("result", result.totalCount);
    } catch (error) {
      console.error("Error fetching services:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleFilterChange = (filterName, value) => {
    setFilters((prev) => {
      let updatedFilters;

      if (filterName === "sRating") {
        updatedFilters = { ...prev, [filterName]: Number(value?.charAt(0)) };
      } else if (filterName === "typeOfWork" && typeof value === "object") {
        updatedFilters = { ...prev, [filterName]: value.id }; // Store ID
      } else {
        updatedFilters = { ...prev, [filterName]: value };
      }

      updatedFilters.pageNo = 1;

      const params = new URLSearchParams();
      Object.keys(updatedFilters).forEach((key) => {
        if (updatedFilters[key] && !["pageSize", "pageNo"].includes(key)) {
          params.append(key, updatedFilters[key]);
        }
      });

      setSearchParams(params);
      return updatedFilters;
    });
  };

  useEffect(() => {
    const typeOfWorkId = searchParams.get("typeOfWork") || null;

    const typeOfWorkOptions =
      allFilter.find((f) => f.filterType === "Type of Work")?.filterOptions ||
      [];

    const typeOfWorkOption = typeOfWorkOptions.find(
      (opt) => String(opt.id) === typeOfWorkId
    );

    setFilters({
      pageSize: 10,
      pageNo: 1,
      fiterParam: "",
      category:
        searchParams.get("category")?.replace(/\$/g, "&")?.replace(/-/g, " ") ||
        "",
      subCategory:
        searchParams
          .get("subCategory")
          ?.replace(/\$/g, "&")
          ?.replace(/-/g, " ") || "",
      locality: searchParams.get("locality") || "",
      typeOfWork: typeOfWorkOption?.id || null,
      providerType:
        searchParams
          .get("providerType")
          ?.replace(/\$/g, "&")
          ?.replace(/-/g, " ") || "",
      typeOfService: searchParams.get("typeOfService") || "",
      premiseType: searchParams.get("premiseType") || "",
      sRating: Number(searchParams.get("sRating")?.charAt(0)) || null,
    });
  }, [searchParams, allFilter]);

  const handleClearFilters = () => {
    setFilters({
      pageSize: 10,
      pageNo: 1,
      fiterParam: "",
      category: "",
      subCategory: "",
      locality: "",
      typeOfWork: null,
      typeOfService: "",
      premiseType: "",
      sRating: null,
    });
    setSearchParams(new URLSearchParams());
  };

  const toggleExpanded = (filterName) => {
    setExpandedFilters((prev) => ({
      ...prev,
      [filterName]: !prev[filterName],
    }));
  };
  const handleCardClick = (typeOfWorkObj) => {
    navigate(`/services?typeOfWork=${typeOfWorkObj.id}`);
  };

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [filters.pageNo]);
  useEffect(() => {
    fetchServices();
  }, [filters]);
  return (
    <section className="service-section">
      <div className="container">
        <div className="row">
          <div className="col-12 col-md-8">
            <div className="inner-banner-wrap">
              <img src={serviceImage.topBanner} alt="" />
            </div>
          </div>
          <div className="col-12 col-md-4">
            <div className="inner-banner-wrap-offers">
              <img src={serviceImage.topBanner2} alt="" />
            </div>
          </div>
          <div className="col-12 d-flex justify-content-between service-header-wrapper">
            <div className="section-title">
              <h2>
                {(() => {
                  const subRaw = searchParams.get("subCategory");
                  const subCategory = subRaw
                    ?.replace(/\$/g, "&")
                    ?.replace(/-/g, " ")
                    ?.trim();

                  const typeOfWorkId = searchParams.get("typeOfWork");
                  const typeOfWorkName = allFilter
                    .find((f) => f.filterType === "Type of Work")
                    ?.filterOptions.find(
                      (opt) => String(opt.id) === typeOfWorkId
                    )?.workTypeName;

                  const categoryRaw = searchParams.get("category");
                  const category = categoryRaw
                    ?.replace(/\$/g, "&")
                    ?.replace(/-/g, " ")
                    ?.trim();

                  const label = typeOfWorkName || subCategory || category;

                  return label
                    ? `${label} in Bengaluru`
                    : "Services in Bengaluru";
                })()}
              </h2>
            </div>

            <div className="d-xl-none">
              <button
                className="btn orange-btn"
                onClick={() => setShowFilters(!showFilters)}
              >
                Filters <FontAwesomeIcon icon={faFilter} />
              </button>
            </div>
          </div>

          <div
            className={`col-12 col-md-3 filter-open ${
              showFilters ? "open" : ""
            }`}
          >
            <div className="d-xl-none ">
              <button
                className="close-button"
                onClick={() => setShowFilters(false)}
              >
                <FontAwesomeIcon icon={faTimes} />
              </button>
            </div>
            <div className="filter-wrap">
              <div className="filter-topbar">
                <h3>Filters</h3>
                <div className="clear-filter" onClick={handleClearFilters}>
                  Clear Filters
                </div>
              </div>
              <Accordion
                defaultActiveKey={allFilter.map(
                  (_, index) => `filter-acc-${index}`
                )}
                alwaysOpen
              >
                <div className="filter-items-wrap">
                  {allFilter.map((filter, index) => (
                    <>
                      <Accordion.Item
                        eventKey={`filter-acc-${index}`}
                        className="filter-item"
                      >
                        <Accordion.Header>{filter.filterType}</Accordion.Header>
                        <Accordion.Body>
                          {(expandedFilters[filter.filteroptionname]
                            ? filter.filterOptions
                            : filter.filterOptions.slice(0, 5)
                          ).map((option, i) => {
                            const inputId = `${filter.filteroptionname}-${i}`;
                            return (
                              <div key={i} className="form-group custom-radio">
                                <input
                                  type="radio"
                                  id={inputId}
                                  name={filter.filteroptionname}
                                  value={option.id || option}
                                  checked={
                                    filter.filteroptionname === "sRating"
                                      ? filters.sRating ===
                                        Number(option.charAt(0))
                                      : filters[filter.filteroptionname] ===
                                        (option.id || option)
                                  }
                                  onChange={() =>
                                    handleFilterChange(
                                      filter.filteroptionname,
                                      option
                                    )
                                  }
                                />
                                <label
                                  htmlFor={inputId}
                                  style={{
                                    fontWeight:
                                      filters[filter.filteroptionname] ===
                                      (option.id || option)
                                        ? "bold"
                                        : "normal",
                                  }}
                                >
                                  {option.workTypeName || option}
                                </label>
                              </div>
                            );
                          })}
                          {filter.filterOptions.length > 5 && (
                            <Link
                              className="show-more-btn"
                              onClick={() =>
                                toggleExpanded(filter.filteroptionname)
                              }
                            >
                              {expandedFilters[filter.filteroptionname]
                                ? "Show less"
                                : "Show more.."}
                            </Link>
                          )}
                        </Accordion.Body>
                      </Accordion.Item>
                    </>
                  ))}
                </div>
              </Accordion>
            </div>
          </div>

          <div className="col-12 col-md-8 col-lg-8 col-xl-6">
            {loading ? (
              <div className="text-center my-4">
                <ProgressSpinner
                  style={{ width: "50px", height: "50px" }}
                  strokeWidth="3"
                  fill="var(--surface-ground)"
                />
              </div>
            ) : Array.isArray(services) && services.length > 0 ? (
              services.map((service) => (
                <ServiceCard key={service.id} service={service} />
              ))
            ) : (
              <p>
                We will be adding vendors to the database for this service
                soon!!
              </p>
            )}
            {totalCount > filters.pageSize && (
              <div className="d-flex justify-content-center mt-4">
                <Pagination
                  pageS={filters.pageSize}
                  cPage={filters.pageNo}
                  pCount={totalCount}
                  onPageChange={(pageNumber) =>
                    setFilters((prev) => ({ ...prev, pageNo: pageNumber }))
                  }
                />
              </div>
            )}
          </div>

          <div className="col-12 col-md-4 col-lg-4 col-xl-3">
            <div className="right-side-bar">
              <div className="category-wrap">
                <h3>Other Services</h3>
                <ul>
                  <li>
                    <div
                      onClick={() =>
                        handleCardClick({
                          id: 44,
                          workTypeName: "CCTV - Repair & AMC ",
                        })
                      }
                    >
                      <div className="icon">
                        <img src={cctv} alt="" />
                      </div>
                      <span>CCTV - Repair & AMC</span>
                    </div>
                  </li>

                  <li>
                    <div
                      onClick={() =>
                        handleCardClick({
                          id: 8,
                          workTypeName: "DG - AMC and Service",
                        })
                      }
                    >
                      <div className="icon">
                        <img src={dg} alt="" />
                      </div>
                      <span>DG - AMC and Service</span>
                    </div>
                  </li>

                  <li>
                    <div
                      onClick={() =>
                        handleCardClick({
                          id: 40,
                          workTypeName: "WTP - Filter Service",
                        })
                      }
                    >
                      <div className="icon">
                        <img src={wtp} alt="" />
                      </div>
                      <span>WTP - Filter Service</span>
                    </div>
                  </li>
                  <li>
                    <div
                      onClick={() =>
                        handleCardClick({
                          id: 40,
                          workTypeName: "STP - Filter Service",
                        })
                      }
                    >
                      <div className="icon">
                        <img src={stp} alt="" />
                      </div>
                      <span>STP - Filter Service</span>
                    </div>
                  </li>
                  <li>
                    <div
                      onClick={() =>
                        handleCardClick({
                          id: 33,
                          workTypeName: "Motors/Pumps - Repair & Service",
                        })
                      }
                    >
                      <div className="icon">
                        <img src={motor} alt="" />
                      </div>
                      <span>Motors/Pumps - Repair & Service</span>
                    </div>
                  </li>
                  <li>
                    <div
                      onClick={() =>
                        handleCardClick({
                          id: 37,
                          workTypeName: "Fire & Safety",
                        })
                      }
                    >
                      <div className="icon">
                        <img src={firSafety} alt="" />
                      </div>
                      <span>Fire & Safety</span>
                    </div>
                  </li>
                  <li>
                    <div
                      onClick={() =>
                        handleCardClick({
                          id: 30,
                          workTypeName: "HT & LT works",
                        })
                      }
                    >
                      <div className="icon">
                        <img src={htlt} alt="" />
                      </div>
                      <span>HT & LT works</span>
                    </div>
                  </li>
                  <li>
                    <div
                      onClick={() =>
                        handleCardClick({
                          id: 19,
                          workTypeName: "Lift Maintenance",
                        })
                      }
                    >
                      <div className="icon">
                        <img src={lift} alt="" />
                      </div>
                      <span>Lift - Repair and Service</span>
                    </div>
                  </li>
                  <li>
                    <div
                      onClick={() =>
                        handleCardClick({
                          id: 7,
                          workTypeName: "Transformer Service/AMC",
                        })
                      }
                    >
                      <div className="icon">
                        <img src={transformer} alt="" />
                      </div>
                      <span>Transformer Service/AMC</span>
                    </div>
                  </li>
                  <li>
                    <div
                      onClick={() =>
                        handleCardClick({
                          id: 10,
                          workTypeName: "Borewell - New & Service",
                        })
                      }
                    >
                      <div className="icon">
                        <img src={boreWell} alt="" />
                      </div>
                      <span>Borewell - New & Service</span>
                    </div>
                  </li>
                </ul>
              </div>
              <div className="vander-data">
                <div className="image">
                  <img src={serviceImage.rightSideBanner} alt="" />
                </div>
                <div className="text-center mt-3">
                  <Link to="/contact-us" className="text-link">
                    Get in Touch
                    <FontAwesomeIcon icon={faArrowRight} />
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Services;
